<template>
  <div class="container-main">
    <bannerVideo bg="#949590" videoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/ms_little.mp4" allVideoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/ms_little-all.mov" title="双师小组课" message="魔法校老师授课，机构学生随时随地在线上课，机构辅导老师通过摄像头和数据关注学生学习情况，全程伴学"></bannerVideo>
    <teacherTeam bg="#F8F9FD" :main="teamConfig.main" :sub="teamConfig.sub" :typeName="teamConfig.typeName" :typeTitle="teamConfig.typeTitle" :teacherUrl="teamConfig.teacherUrl" :typeDes="teamConfig.typeDes"></teacherTeam>
    <supportTeacher main="辅导老师线上全程伴学"  sub='让每个孩子都能受到关注' :showBg="true" :configList="supportList"></supportTeacher>
    <littleBig bg="#F8F9FD" main="双师小组课对比大班网课的优势" sub="主讲老师高频互动，辅导老师全程线上伴学，学生上在线课更有参与"></littleBig>
    <cloudLearn></cloudLearn>
    <subjectIntro bg="#F8F9FD" :hasSub="hasSub"></subjectIntro>
    <supportTeacher main="让每个孩子的学习更有参与感" :desH="120" sub='辅导老师课中关注每个孩子的学习情况'  :configList="learnList"></supportTeacher>
  </div>
</template>
<script>
import teacherTeam from './components/techerTeam'
import bannerVideo from './components/bannerVideo/bannerVideo'
import supportTeacher from './components/supportTeacher'
import littleBig from './components/litteBig'
import cloudLearn from './components/cloudLearn'
import subjectIntro from './components/subject-intro'
import { ssTeacherTeam, supportList, learnList } from '@/const/index'
export default {
  data () {
    return {
      teamConfig: ssTeacherTeam,
      hasSub: [1, 2, 3, 4, 5],
      supportList: supportList,
      learnList: learnList
    }
  },
  components: { bannerVideo, teacherTeam, supportTeacher, littleBig, cloudLearn, subjectIntro }
}
</script>
